import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

const AdvertiserFilterCard = ({
  filters,
  handleFilterChange,
  handleClearFilters,
  setCurrentPage,
  onAddNewClick,
}) => {
  return (
    <>
      <Row className="">
        <Col lg="12">
          <Card className="border-0 shadow-sm">
            <CardHeader className="bg-light">
              <Row className="align-items-center justify-content-between w-100">
                <Col md="auto">
                  <h5 className="mb-0 d-flex align-items-center gap-2">
                    <i className="bx bx-filter-alt"></i> Search & Filter
                  </h5>
                </Col>

                <Col md="auto" className="d-flex gap-2">
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => setCurrentPage(1)}
                  >
                    <i className="bx bx-search me-2"></i>Apply Filters
                  </Button>
                  <Button
                    color="secondary"
                    outline
                    size="sm"
                    onClick={handleClearFilters}
                  >
                    <i className="bx bx-reset me-2"></i>Clear All
                  </Button>

                  <Button color="success" size="sm" onClick={onAddNewClick}>
                    <i className="bx bx-plus me-2"></i>
                    New Advertiser
                  </Button>
                </Col>
              </Row>
            </CardHeader>

            <CardBody>
              <Row className="align-items-end justify-content-between g-3">
                {/* 🔹 Left Side (Search Filters) */}
                <Col md="8">
                  <Row className="g-3">
                    {/* Advertiser Name */}
                    <Col md="4">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">Advertiser Name</Label>
                        <Input
                          type="text"
                          placeholder="Search by name..."
                          value={filters.advertiserName}
                          onChange={(e) =>
                            handleFilterChange("advertiserName", e.target.value)
                          }
                          bsSize="md"
                        />
                      </FormGroup>
                    </Col>

                    {/* Email */}
                    <Col md="4">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">Email</Label>
                        <Input
                          type="email"
                          placeholder="Search by email..."
                          value={filters.advertiserEmail}
                          onChange={(e) =>
                            handleFilterChange(
                              "advertiserEmail",
                              e.target.value,
                            )
                          }
                          bsSize="md"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>

                {/* 🔹 Right Side (Button) */}
                {/* <Col
                  md="2"
                  className="d-flex justify-content-md-end align-items-center align-content-center justify-content-center"
                >
                  <Button color="success" size="md" onClick={onAddNewClick}>
                    <i className="bx bx-plus me-2"></i>
                    New Advertiser
                  </Button>
                </Col> */}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AdvertiserFilterCard;
